const lcs = require('node-lcs')
const Big = require('big.js')

//lcs方式合并字符串
export const mergeLcs = (v1, v2) => {
  if (v1 == null) {
    v1 = ''
  }
  if (v2 == null) {
    v2 = ''
  }
  if (v1.indexOf(v2) !== -1) {
    return v1
  }
  if (v2.indexOf(v1) !== -1) {
    return v2
  }
  const common = lcs(v1, v2)
  if (common.length > 10) {
    v2 = v2.replace(common.sequence, '')
  }
  v2 = `${v2};${v1}`
  return v2
}
// cv字段整理
export const formatCvData = cvData => {
  const radishData = {}
  const expData = {
    教育: [],
    工作: [],
    项目: [],
  }
  Object.keys(cvData).forEach(key => {
    const val = cvData[key]
    if (val) {
      if (key === '从业起始年') {
        radishData[key] = parseInt(val, 10)
      } else if (!['工作经历', '教育经历', '项目经历'].includes(key)) {
        radishData[key] = val
      }
    }
  })
  if (cvData['工作经历'] && cvData['工作经历'].length > 0) {
    cvData['工作经历'][0]['当前公司'] = true
    expData['工作'] = cvData['工作经历']
  }
  if (cvData['教育经历'] && cvData['教育经历'].length > 0) {
    expData['教育'] = cvData['教育经历']
  }
  if (cvData['项目经历'] && cvData['项目经历'].length > 0) {
    expData['项目'] = cvData['项目经历']
  }
  return { radishData, expData }
}
// 数组是否相等
export const isArrEq = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false
  }
  const str1 = arr1.sort().join(';')
  const str2 = arr2.sort().join(';')
  if (str1 === str2) {
    return true
  }
  return false
}
// 数组是否子集
export const isSubset = (arr, arrSub) => {
  if (arrSub.length === 0) {
    return true
  }
  let count = 0
  arrSub.forEach(sub => {
    if (arr.includes(sub)) {
      count = count + 1
    }
  })
  if (count === arrSub.length) {
    return true
  }
  return false
}
// 数组是否交集
export const hasIntersection = (arr1, arr2) => {
  if (arr1.length === 0 || arr2.length === 0) {
    return false
  }
  let count = 0
  arr2.forEach(a => {
    if (arr1.includes(a)) {
      count = count + 1
    }
  })
  if (count > 0) {
    return true
  }
  return false
}
// 小数加
export const floatAdd = (arg1, arg2) => {
  let tmp = new Big(arg1)
  let res = parseFloat(tmp.plus(arg2).toString())
  return res
}
// 小数乘
export const floatMul = (arg1, arg2) => {
  let tmp = new Big(arg1)
  let res = parseFloat(tmp.times(arg2).toString())
  return res
}
// 根据薪酬和百分比计算佣金
export const getYongJin = (money, percent) => {
  let tmp = new Big(money)
  let res = parseFloat(
    tmp
      .times(percent)
      .div(100)
      .toString(),
  )
  return res
}
// 年份差
export const yearDiff = (start, end) => {
  if (!start || !end) return null
  start = start.trim()
  end = end.trim()
  let startYear, endYear, startMonth, endMonth
  if (end == '至今') {
    const now = new Date()
    endYear = now.getFullYear()
    endMonth = now.getMonth() + 1
  } else {
    const endArr = end.split('.')
    if (!endArr[0] || isNaN(parseInt(endArr[0]))) return null
    endYear = parseInt(endArr[0])
    endMonth = endArr[1] ? parseInt(endArr[1]) : 1
  }
  const startArr = start.split('.')
  if (!startArr[0] || isNaN(parseInt(startArr[0]))) return null
  startYear = parseInt(startArr[0])
  startMonth = startArr[1] ? parseInt(startArr[1]) : 1
  let yearDiff = endYear - startYear
  if (yearDiff < 0) return null
  let monthDiff = endMonth - startMonth
  if (monthDiff < 0) {
    monthDiff = 12 - startMonth + endMonth
    yearDiff = yearDiff - 1
  }
  return (yearDiff ? yearDiff + '年' : '') + (monthDiff ? monthDiff + '个月' : '')
}
// 年龄
export const getAge = birth => {
  if (!birth) return null
  const now = new Date()
  const endYear = now.getFullYear()
  const birthStr = `${birth}`.trim()
  let startArr = birthStr.indexOf('.') !== -1 ? birthStr.split('.') : birthStr.split('-')
  if (!startArr[0] || isNaN(parseInt(startArr[0]))) return null
  const startYear = parseInt(startArr[0])
  const age = endYear - startYear
  if (age < 0) return null
  return age
}
// 百分比
export const formatPercent = (numerator, denominator) => {
  if (!numerator || !denominator || isNaN(numerator) || isNaN(denominator)) return 0
  return Math.round(new Big(numerator).div(denominator) * 100)
}
// 周日0点
export const getWeekStart = date => {
  const now = date || new Date()
  const nowDayOfWeek = now.getDay() // 今天本周的第几天
  const nowDay = now.getDate() // 当前日
  const nowMonth = now.getMonth() // 当前月
  let nowYear = now.getYear() // 当前年
  nowYear += nowYear < 2000 ? 1900 : 0
  const weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek)
  return weekStartDate
}
// 周六24点
export const getWeekEnd = date => {
  const now = date || new Date()
  const nowDayOfWeek = now.getDay() // 今天本周的第几天
  const nowDay = now.getDate() // 当前日
  const nowMonth = now.getMonth() // 当前月
  let nowYear = now.getYear() // 当前年
  nowYear += nowYear < 2000 ? 1900 : 0
  const weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
  return weekEndDate
}
// 月第一天
export const getMonthStart = date => {
  const now = date || new Date()
  const nowMonth = now.getMonth() // 当前月
  let nowYear = now.getYear() // 当前年
  nowYear += nowYear < 2000 ? 1900 : 0
  const monthStartDate = new Date(nowYear, nowMonth, 1)
  return monthStartDate
}
// 手机格式验证
export const countryCodes = [
  { reg: /^(86){0,1}1\d{10}$/, code: '86', shortName: 'CN', enName: 'Mainland China', cnName: '中国大陆' },
  { reg: /^(00){0,1}(886){1}0{0,1}[6,7,9](?:\d{7}|\d{8}|\d{10})$/, code: '886', shortName: 'TW', enName: 'Taiwan(China)', cnName: '中国台湾地区' },
  { reg: /^(00){0,1}(852){1}0{0,1}[1,5,6,9](?:\d{7}|\d{8}|\d{12})$/, code: '852', shortName: 'HK', enName: 'Hong Kong(China)', cnName: '中国香港' },
  { reg: /^(00){0,1}(853){1}6\d{7}$/, code: '853', shortName: 'MO', enName: 'Macao(China)', cnName: '中国澳门' },
  { reg: /^(00){0,1}(60){1}1\d{8,9}$/, code: '60', shortName: 'MY', enName: 'Malaysia', cnName: '马来西亚' },
  { reg: /^(00){0,1}(65){1}[13689]\d{6,7}$/, code: '65', shortName: 'SG', enName: 'Singapore', cnName: '新加坡' },
  { reg: /^(00){0,1}(81){1}0{0,1}[7,8,9](?:\d{8}|\d{9})$/, code: '81', shortName: 'JP', enName: 'Japan', cnName: '日本' },
  { reg: /^(00){0,1}(82){1}0{0,1}[7,1](?:\d{8}|\d{9})$/, code: '82', shortName: 'KR', enName: 'Korea', cnName: '韩国' },
  { reg: /^(00){0,1}(1){1}\d{10,12}$/, code: '1', shortName: 'US', enName: 'United States of America', cnName: '美国' },
  { reg: /^(00){0,1}(1){1}\d{10}$/, code: '1', shortName: 'CA', enName: 'Canada', cnName: '加拿大' },
  { reg: /^(00){0,1}(61){1}4\d{8,9}$/, code: '61', shortName: 'AU', enName: 'Australia', cnName: '澳大利亚' },
  { reg: /^(00){0,1}(64){1}[278]\d{7,9}$/, code: '64', shortName: 'NZ', enName: 'New Zealand', cnName: '新西兰' },
  { reg: /^(00){0,1}(355){1}\d{6,15}$/, code: '355', shortName: 'AL', enName: 'Albania', cnName: '阿尔巴尼亚' },
  { reg: /^(00){0,1}(244){1}\d{6,15}$/, code: '244', shortName: 'AO', enName: 'Angola', cnName: '安哥拉' },
  { reg: /^(00){0,1}(54){1}\d{6,12}$/, code: '54', shortName: 'AR', enName: 'Argentina', cnName: '阿根廷' },
  { reg: /^(00){0,1}(43){1}\d{6,12}$/, code: '43', shortName: 'AT', enName: 'Austria', cnName: '奥地利' },
  { reg: /^(00){0,1}(994){1}\d{6,15}$/, code: '994', shortName: 'AZ', enName: 'Azerbaijan', cnName: '阿塞拜疆' },
  { reg: /^(00){0,1}(1242){1}\d{6,12}$/, code: '1242', shortName: 'BS', enName: 'Bahamas', cnName: '巴哈马' },
  { reg: /^(00){0,1}(973){1}\d{6,15}$/, code: '973', shortName: 'BH', enName: 'Bahrain', cnName: '巴林' },
  { reg: /^(00){0,1}(375){1}\d{6,12}$/, code: '375', shortName: 'BY', enName: 'Belarus', cnName: '白俄罗斯' },
  { reg: /^(00){0,1}(32){1}\d{6,12}$/, code: '32', shortName: 'BE', enName: 'Belgium', cnName: '比利时' },
  { reg: /^(00){0,1}(501){1}\d{6,12}$/, code: '501', shortName: 'BZ', enName: 'Belize', cnName: '伯利兹' },
  { reg: /^(00){0,1}(229){1}\d{6,15}$/, code: '229', shortName: 'BJ', enName: 'Benin', cnName: '贝宁' },
  { reg: /^(00){0,1}(591){1}\d{6,15}$/, code: '591', shortName: 'BO', enName: 'Bolivia', cnName: '玻利维亚' },
  { reg: /^(00){0,1}(55){1}\d{6,12}$/, code: '55', shortName: 'BR', enName: 'Brazil', cnName: '巴西' },
  { reg: /^(00){0,1}(673){1}\d{6,15}$/, code: '673', shortName: 'BN', enName: 'Brunei', cnName: '文莱' },
  { reg: /^(00){0,1}(359){1}\d{6,12}$/, code: '359', shortName: 'BG', enName: 'Bulgaria', cnName: '保加利亚' },
  { reg: /^(00){0,1}(226){1}\d{6,15}$/, code: '226', shortName: 'BF', enName: 'Burkina Faso', cnName: '布基纳法索' },
  { reg: /^(00){0,1}(855){1}\d{6,12}$/, code: '855', shortName: 'KH', enName: 'Cambodia', cnName: '柬埔寨' },
  { reg: /^(00){0,1}(237){1}\d{6,15}$/, code: '237', shortName: 'CM', enName: 'Cameroon', cnName: '喀麦隆' },
  { reg: /^(00){0,1}(238){1}\d{6,15}$/, code: '238', shortName: 'CV', enName: 'Cape Verde', cnName: '佛得角' },
  { reg: /^(00){0,1}(1345){1}\d{6,15}$/, code: '1345', shortName: 'KY', enName: 'Cayman Islands', cnName: '开曼群岛' },
  { reg: /^(00){0,1}(235){1}\d{6,15}$/, code: '235', shortName: 'TD', enName: 'Chad', cnName: '乍得' },
  { reg: /^(00){0,1}(56){1}\d{6,12}$/, code: '56', shortName: 'CL', enName: 'Chile', cnName: '智利' },
  { reg: /^(00){0,1}(57){1}\d{6,12}$/, code: '57', shortName: 'CO', enName: 'Colombia', cnName: '哥伦比亚' },
  { reg: /^(00){0,1}(269){1}\d{6,15}$/, code: '269', shortName: 'KM', enName: 'Comoros', cnName: '科摩罗和马约特' },
  { reg: /^(00){0,1}(506){1}\d{6,15}$/, code: '506', shortName: 'CR', enName: 'Costa Rica', cnName: '哥斯达黎加' },
  { reg: /^(00){0,1}(385){1}\d{6,15}$/, code: '385', shortName: 'HR', enName: 'Croatia', cnName: '克罗地亚' },
  { reg: /^(00){0,1}(357){1}\d{6,15}$/, code: '357', shortName: 'CY', enName: 'Cyprus', cnName: '塞浦路斯' },
  { reg: /^(00){0,1}(45){1}\d{6,12}$/, code: '45', shortName: 'DK', enName: 'Denmark', cnName: '丹麦' },
  { reg: /^(00){0,1}(253){1}\d{6,15}$/, code: '253', shortName: 'DJ', enName: 'Djibouti', cnName: '吉布提' },
  { reg: /^(00){0,1}(20){1}\d{6,12}$/, code: '20', shortName: 'EG', enName: 'Egypt', cnName: '埃及' },
  { reg: /^(00){0,1}(503){1}\d{6,15}$/, code: '503', shortName: 'SV', enName: 'El Salvador', cnName: '萨尔瓦多' },
  { reg: /^(00){0,1}(240){1}\d{6,15}$/, code: '240', shortName: 'GQ', enName: 'Equatorial Guinea', cnName: '赤道几内亚' },
  { reg: /^(00){0,1}(372){1}\d{6,12}$/, code: '372', shortName: 'EE', enName: 'Estonia', cnName: '爱沙尼亚' },
  { reg: /^(00){0,1}(358){1}\d{6,12}$/, code: '358', shortName: 'FI', enName: 'Finland', cnName: '芬兰' },
  { reg: /^(00){0,1}(33){1}(\d{6}|\d{8,9})$/, code: '33', shortName: 'FR', enName: 'France', cnName: '法国' },
  { reg: /^(00){0,1}(241){1}\d{6,15}$/, code: '241', shortName: 'GA', enName: 'Gabon', cnName: '加蓬' },
  { reg: /^(00){0,1}(220){1}\d{6,15}$/, code: '220', shortName: 'GM', enName: 'Gambia', cnName: '冈比亚' },
  { reg: /^(00){0,1}(995){1}\d{6,15}$/, code: '995', shortName: 'GE', enName: 'Georgia', cnName: '格鲁吉亚' },
  { reg: /^(00){0,1}(49){1}1(\d{5,6}|\d{9,12})$/, code: '49', shortName: 'DE', enName: 'Germany', cnName: '德国' },
  { reg: /^(00){0,1}(30){1}\d{6,12}$/, code: '30', shortName: 'GR', enName: 'Greece', cnName: '希腊' },
  { reg: /^(00){0,1}(1473){1}\d{6,15}$/, code: '1473', shortName: 'GD', enName: 'Grenada', cnName: '格林纳达' },
  { reg: /^(00){0,1}(502){1}\d{6,15}$/, code: '502', shortName: 'GT', enName: 'Guatemala', cnName: '危地马拉' },
  { reg: /^(00){0,1}(224){1}\d{6,15}$/, code: '224', shortName: 'GN', enName: 'Guinea', cnName: '几内亚' },
  { reg: /^(00){0,1}(245){1}\d{6,15}$/, code: '245', shortName: 'GW', enName: 'Guinea-Bissau', cnName: '几内亚比绍' },
  { reg: /^(00){0,1}(592){1}\d{6,15}$/, code: '592', shortName: 'GY', enName: 'Guyana', cnName: '法属圭亚那' },
  { reg: /^(00){0,1}(504){1}\d{6,15}$/, code: '504', shortName: 'HN', enName: 'Honduras', cnName: '洪都拉斯' },
  { reg: /^(00){0,1}(36){1}\d{6,12}$/, code: '36', shortName: 'HU', enName: 'Hungary', cnName: '匈牙利' },
  { reg: /^(00){0,1}(91){1}\d{6,12}$/, code: '91', shortName: 'IN', enName: 'India', cnName: '印度' },
  { reg: /^(00){0,1}(62){1}[2-9]\d{7,11}$/, code: '62', shortName: 'ID', enName: 'Indonesia', cnName: '印度尼西亚' },
  { reg: /^(00){0,1}(353){1}\d{6,12}$/, code: '353', shortName: 'IE', enName: 'Ireland', cnName: '爱尔兰' },
  { reg: /^(00){0,1}(972){1}\d{6,12}$/, code: '972', shortName: 'IL', enName: 'Israel', cnName: '以色列' },
  { reg: /^(00){0,1}(39){1}[37]\d{8,11}$/, code: '39', shortName: 'IT', enName: 'Italy', cnName: '意大利' },
  { reg: /^(00){0,1}(1876){1}\d{6,15}$/, code: '1876', shortName: 'JM', enName: 'Jamaica', cnName: '牙买加' },
  { reg: /^(00){0,1}(962){1}\d{6,12}$/, code: '962', shortName: 'JO', enName: 'Jordan', cnName: '约旦' },
  { reg: /^(00){0,1}(254){1}\d{6,15}$/, code: '254', shortName: 'KE', enName: 'Kenya', cnName: '肯尼亚' },
  { reg: /^(00){0,1}(965){1}\d{6,15}$/, code: '965', shortName: 'KW', enName: 'Kuwait', cnName: '科威特' },
  { reg: /^(00){0,1}(996){1}\d{6,12}$/, code: '996', shortName: 'KG', enName: 'Kyrgyzstan', cnName: '吉尔吉斯斯坦' },
  { reg: /^(00){0,1}(371){1}\d{6,15}$/, code: '371', shortName: 'LV', enName: 'Latvia', cnName: '拉脱维亚' },
  { reg: /^(00){0,1}(266){1}\d{6,15}$/, code: '266', shortName: 'LS', enName: 'Lesotho', cnName: '莱索托' },
  { reg: /^(00){0,1}(370){1}\d{6,12}$/, code: '370', shortName: 'LT', enName: 'Lithuania', cnName: '立陶宛' },
  { reg: /^(00){0,1}(352){1}\d{6,12}$/, code: '352', shortName: 'LU', enName: 'Luxembourg', cnName: '卢森堡' },
  { reg: /^(00){0,1}(261){1}\d{6,15}$/, code: '261', shortName: 'MG', enName: 'Madagascar', cnName: '马达加斯加' },
  { reg: /^(00){0,1}(265){1}\d{6,15}$/, code: '265', shortName: 'MW', enName: 'Malawi', cnName: '马拉维' },
  { reg: /^(00){0,1}(960){1}\d{6,12}$/, code: '960', shortName: 'MV', enName: 'Maldives', cnName: '马尔代夫' },
  { reg: /^(00){0,1}(223){1}\d{6,15}$/, code: '223', shortName: 'ML', enName: 'Mali', cnName: '马里' },
  { reg: /^(00){0,1}(222){1}\d{6,15}$/, code: '222', shortName: 'MR', enName: 'Mauritania', cnName: '毛里塔尼亚' },
  { reg: /^(00){0,1}(230){1}\d{6,15}$/, code: '230', shortName: 'MU', enName: 'Mauritius', cnName: '毛里求斯' },
  { reg: /^(00){0,1}(52){1}\d{6,12}$/, code: '52', shortName: 'MX', enName: 'Mexico', cnName: '墨西哥' },
  { reg: /^(00){0,1}(373){1}\d{6,15}$/, code: '373', shortName: 'MD', enName: 'Moldova', cnName: '摩尔多瓦' },
  { reg: /^(00){0,1}(976){1}\d{6,12}$/, code: '976', shortName: 'MN', enName: 'Mongolia', cnName: '蒙古' },
  { reg: /^(00){0,1}(212){1}\d{6,12}$/, code: '212', shortName: 'MA', enName: 'Morocco', cnName: '摩洛哥' },
  { reg: /^(00){0,1}(258){1}\d{6,15}$/, code: '258', shortName: 'MZ', enName: 'Mozambique', cnName: '莫桑比克' },
  { reg: /^(00){0,1}(264){1}\d{6,15}$/, code: '264', shortName: 'NA', enName: 'Namibia', cnName: '纳米比亚' },
  { reg: /^(00){0,1}(31){1}6\d{8}$/, code: '31', shortName: 'NL', enName: 'Holland', cnName: '荷兰' },
  { reg: /^(00){0,1}(505){1}\d{6,15}$/, code: '505', shortName: 'NI', enName: 'Nicaragua', cnName: '尼加拉瓜' },
  { reg: /^(00){0,1}(227){1}\d{6,15}$/, code: '227', shortName: 'NE', enName: 'Niger', cnName: '尼日尔' },
  { reg: /^(00){0,1}(234){1}\d{6,12}$/, code: '234', shortName: 'NG', enName: 'Nigeria', cnName: '尼日利亚' },
  { reg: /^(00){0,1}(47){1}\d{6,12}$/, code: '47', shortName: 'NO', enName: 'Norway', cnName: '挪威' },
  { reg: /^(00){0,1}(968){1}\d{6,15}$/, code: '968', shortName: 'OM', enName: 'Oman', cnName: '阿曼' },
  { reg: /^(00){0,1}(970){1}\d{6,15}$/, code: '970', shortName: 'PS', enName: 'Palestine', cnName: '巴勒斯坦' },
  { reg: /^(00){0,1}(507){1}\d{6,12}$/, code: '507', shortName: 'PA', enName: 'Panama', cnName: '巴拿马' },
  { reg: /^(00){0,1}(675){1}\d{6,15}$/, code: '675', shortName: 'PG', enName: 'Papua New Guinea', cnName: '巴布亚新几内亚' },
  { reg: /^(00){0,1}(51){1}\d{6,12}$/, code: '51', shortName: 'PE', enName: 'Peru', cnName: '秘鲁' },
  { reg: /^(00){0,1}(63){1}[24579](\d{7,9}|\d{12})$/, code: '63', shortName: 'PH', enName: 'Philippines', cnName: '菲律宾' },
  { reg: /^(00){0,1}(48){1}\d{6,12}$/, code: '48', shortName: 'PL', enName: 'Poland', cnName: '波兰' },
  { reg: /^(00){0,1}(351){1}\d{6,12}$/, code: '351', shortName: 'PT', enName: 'Portugal', cnName: '葡萄牙' },
  { reg: /^(00){0,1}(974){1}\d{6,12}$/, code: '974', shortName: 'QA', enName: 'Qatar', cnName: '卡塔尔' },
  { reg: /^(00){0,1}(40){1}\d{6,12}$/, code: '40', shortName: 'RO', enName: 'Romania', cnName: '罗马尼亚' },
  { reg: /^(00){0,1}(7){1}[13489]\d{9,11}$/, code: '7', shortName: 'RU', enName: 'Russia', cnName: '俄罗斯' },
  { reg: /^(00){0,1}(250){1}\d{6,15}$/, code: '250', shortName: 'RW', enName: 'Rwanda', cnName: '卢旺达' },
  { reg: /^(00){0,1}(966){1}\d{6,12}$/, code: '966', shortName: 'SA', enName: 'Saudi Arabia', cnName: '沙特' },
  { reg: /^(00){0,1}(221){1}\d{6,15}$/, code: '221', shortName: 'SN', enName: 'Senegal', cnName: '塞内加尔' },
  { reg: /^(00){0,1}(381){1}\d{6,12}$/, code: '381', shortName: 'RS', enName: 'Serbia', cnName: '塞尔维亚' },
  { reg: /^(00){0,1}(248){1}\d{6,12}$/, code: '248', shortName: 'SC', enName: 'Seychelles', cnName: '塞舌尔' },
  { reg: /^(00){0,1}(232){1}\d{6,15}$/, code: '232', shortName: 'SL', enName: 'Sierra Leone', cnName: '塞拉利昂' },
  { reg: /^(00){0,1}(421){1}\d{6,15}$/, code: '421', shortName: 'SK', enName: 'Slovakia', cnName: '斯洛伐克' },
  { reg: /^(00){0,1}(386){1}\d{6,15}$/, code: '386', shortName: 'SI', enName: 'Slovenia', cnName: '斯洛文尼亚' },
  { reg: /^(00){0,1}(27){1}\d{6,12}$/, code: '27', shortName: 'ZA', enName: 'South Africa', cnName: '南非' },
  { reg: /^(00){0,1}(34){1}\d{6,12}$/, code: '34', shortName: 'ES', enName: 'Spain', cnName: '西班牙' },
  { reg: /^(00){0,1}(94){1}\d{6,12}$/, code: '94', shortName: 'LK', enName: 'Sri Lanka', cnName: '斯里兰卡' },
  { reg: /^(00){0,1}(597){1}\d{6,15}$/, code: '597', shortName: 'SR', enName: 'Suriname', cnName: '苏里南' },
  { reg: /^(00){0,1}(268){1}\d{6,15}$/, code: '268', shortName: 'SZ', enName: 'Swaziland', cnName: '斯威士兰' },
  { reg: /^(00){0,1}(46){1}[124-7](\d{8}|\d{10}|\d{12})$/, code: '46', shortName: 'SE', enName: 'Sweden', cnName: '瑞典' },
  { reg: /^(00){0,1}(41){1}\d{6,12}$/, code: '41', shortName: 'CH', enName: 'Switzerland', cnName: '瑞士' },
  { reg: /^(00){0,1}(992){1}\d{6,15}$/, code: '992', shortName: 'TJ', enName: 'Tajikistan', cnName: '塔吉克斯坦' },
  { reg: /^(00){0,1}(255){1}\d{6,15}$/, code: '255', shortName: 'TZ', enName: 'Tanzania', cnName: '坦桑尼亚' },
  { reg: /^(00){0,1}(66){1}[13456789]\d{7,8}$/, code: '66', shortName: 'TH', enName: 'Thailand', cnName: '泰国' },
  { reg: /^(00){0,1}(228){1}\d{6,15}$/, code: '228', shortName: 'TG', enName: 'Togo', cnName: '多哥' },
  { reg: /^(00){0,1}(1868){1}\d{6,15}$/, code: '1868', shortName: 'TT', enName: 'Trinidad & Tobago', cnName: '特立尼达和多巴哥' },
  { reg: /^(00){0,1}(216){1}\d{6,12}$/, code: '216', shortName: 'TN', enName: 'Tunisia', cnName: '突尼斯' },
  { reg: /^(00){0,1}(90){1}\d{6,12}$/, code: '90', shortName: 'TR', enName: 'Turkey', cnName: '土耳其' },
  { reg: /^(00){0,1}(993){1}\d{6,15}$/, code: '993', shortName: 'TM', enName: 'Turkmenistan', cnName: '土库曼斯坦' },
  { reg: /^(00){0,1}(256){1}\d{6,15}$/, code: '256', shortName: 'UG', enName: 'Uganda', cnName: '乌干达' },
  { reg: /^(00){0,1}(380){1}[3-79]\d{8,9}$/, code: '380', shortName: 'UA', enName: 'Ukraine', cnName: '乌克兰' },
  { reg: /^(00){0,1}(971){1}\d{6,12}$/, code: '971', shortName: 'AE', enName: 'United Arab Emirates', cnName: '阿联酋' },
  { reg: /^(00){0,1}(44){1}[347-9](\d{8,9}|\d{11,12})$/, code: '44', shortName: 'GB', enName: 'United Kingdom', cnName: '英国' },
  { reg: /^(00){0,1}(598){1}\d{6,15}$/, code: '598', shortName: 'UY', enName: 'Uruguay', cnName: '乌拉圭' },
  { reg: /^(00){0,1}(998){1}\d{6,15}$/, code: '998', shortName: 'UZ', enName: 'Uzbekistan', cnName: '乌兹别克斯坦' },
  { reg: /^(00){0,1}(58){1}\d{6,12}$/, code: '58', shortName: 'VE', enName: 'Venezuela', cnName: '委内瑞拉' },
  { reg: /^(00){0,1}(84){1}[1-9]\d{6,9}$/, code: '84', shortName: 'VN', enName: 'Vietnam', cnName: '越南' },
  { reg: /^(00){0,1}(1284){1}\d{6,12}$/, code: '1284', shortName: 'VG', enName: 'Virgin Islands, British', cnName: '英属维京群岛' },
  { reg: /^(00){0,1}(967){1}\d{6,15}$/, code: '967', shortName: 'YE', enName: 'Yemen', cnName: '也门' },
  { reg: /^(00){0,1}(260){1}\d{6,15}$/, code: '260', shortName: 'ZM', enName: 'Zambia', cnName: '赞比亚' },
  { reg: /^(00){0,1}(263){1}\d{6,15}$/, code: '263', shortName: 'ZW', enName: 'Zimbabwe', cnName: '津巴布韦' },
]
export const phoneVali = phoneNum => {
  return /^\d{7,21}$/.test(phoneNum)
}
